import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloRicorsoOpposizione extends FascicoloFull {
  sezione: string;
  motivoOpposizione: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
